import React from "react";
import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, ease: "easeOut", delay }}
    >
      {children}
    </motion.div>
  );
}

export function Overline({ children, className = "" }) {
  return (
    <span className={`font-sans uppercase tracking-[0.22em] text-xs font-medium text-gold-600 ${className}`}>
      {children}
    </span>
  );
}

export function Rule({ className = "" }) {
  return <div className={`h-px w-16 bg-gold-500/50 ${className}`} />;
}

export function Watermark({ text = "GF", className = "" }) {
  return (
    <span aria-hidden="true" className={`gf-watermark ${className}`}>
      {text}
    </span>
  );
}
